import { Link } from 'react-router-dom'
import { useAnnouncements } from '../features/announcements/hooks/useAnnouncements'
import { memberColors } from '../styles/tokens'

export const AnnouncementWidget = () => {
  const { data: announcements = [], isLoading } = useAnnouncements()

  if (isLoading) return null

  // Show the first pinned announcement, or the most recent one
  const featured = announcements.find((a) => a.is_pinned) ?? announcements[0]

  if (!featured) return null

  const color = memberColors[featured.profiles?.member_color] ?? '#7c6faf'
  const initials = (featured.profiles?.display_name ?? '?').slice(0, 2).toUpperCase()
  const date = new Date(featured.created_at).toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
  const snippet = featured.body.replace(/\*\*/g, '').replace(/\*/g, '').slice(0, 120)

  return (
    <Link to="/announcements" className="block bg-surface border border-border rounded-2xl p-5 mb-4 hover:border-primary/30 transition-colors">
      <div className="flex items-center gap-2 mb-2">
        {featured.is_pinned && (
          <svg className="w-3.5 h-3.5 text-primary" fill="currentColor" viewBox="0 0 24 24">
            <path d="M16 12V4h1V2H7v2h1v8l-2 2v2h5.2v6h1.6v-6H18v-2l-2-2z" />
          </svg>
        )}
        <span className="text-xs font-semibold text-text-muted uppercase tracking-wide">
          {featured.is_pinned ? 'Pinned announcement' : 'Latest announcement'}
        </span>
      </div>

      <h3 className="font-semibold text-text-primary mb-1">{featured.title}</h3>
      <p className="text-sm text-text-secondary line-clamp-2 mb-3">
        {snippet}{featured.body.length > 120 ? '…' : ''}
      </p>

      <div className="flex items-center gap-2">
        <div
          className="w-6 h-6 rounded-full flex items-center justify-center text-white text-xs font-bold shrink-0"
          style={{ backgroundColor: color }}
        >
          {initials}
        </div>
        <span className="text-xs text-text-muted">{featured.profiles?.display_name}</span>
        <span className="text-xs text-text-muted ml-auto">{date}</span>
      </div>
    </Link>
  )
}
